/*jshint esversion: 8 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    bookingLines: [],
    monthBookingLines: [],
    editBookingLines: []
  },
  mutations: {
    setBookingLines(state, bookingLines) {
      state.bookingLines = bookingLines;
    },
    setMonthBookingLines(state, monthBookingLines) {
      state.monthBookingLines = monthBookingLines;
    },
    addEditRelevantBookingLines(state, data) {
      while (state.editBookingLines.length > 0) state.editBookingLines.pop();

      state.editBookingLines = state.bookingLines.combinedDates.filter((bookingLine) => bookingLine.delete === 0);

      state.editBookingLines = [...data.lastRelevantBookingLines, ...state.editBookingLines, ...data.nextRelevantBookingLines];
    }
  },
  actions: {
    getBookingLinesForMonth({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/bookingLines/${data.id}/bookingLinesForMonth/${data.date}`,
            method: "GET"
          })
          .then((resp) => {
            if (resp.data.success) commit("setMonthBookingLines", resp.data.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getLastBookingLine({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + `/api/users/bookingLines/${id}/getLastBookingLine`)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getBookingLinesForDay({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/bookingLines/${data.id}/bookingLinesForDay/${data.date}`,
            method: "GET"
          })
          .then((resp) => {
            if (resp.data.success) commit("setBookingLines", resp.data.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getBookingLinesBeforeAndAfterDate({ commit }, data) {
      //commit("resetEditBookingLines");
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/bookingLines/${data.id}/bookingLinesBeforeAndAfterDate/${data.date}`,
            method: "GET"
          })
          .then((resp) => {
            commit("addEditRelevantBookingLines", resp.data.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendBookingLinesCorrection({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/bookingLines/correctedBookingLines`,
            data: data,
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getCommentsForDay({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: `${Vue.prototype.apiUrl}/api/users/bookingLines/${data.employeeId}/getCommentsForDay/${data.date}`,
            method: "GET"
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCommentById({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: `${Vue.prototype.apiUrl}/api/users/bookingLines/${data.employeeId}/getCommentById/${data.commentId}`,
            method: "GET"
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  },
  getters: {
    bookingLines: (state) => state.bookingLines,
    monthBookingLines: (state) => state.monthBookingLines,
    editBookingLines: (state) => state.editBookingLines
  }
};
